import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setHeroTitle, setHeroContent, setHeroImage } from '../../redux/hero.slice'
import FAQSection from '../Home/FAQSection';

const FAQPage = () => { 
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setHeroImage(false));
    dispatch(setHeroTitle(`Frequently Asked Questions`));
    dispatch(setHeroContent(`Manage your badminton club more efficiently with ShuttleOps. Designed specifically for club managers, our platform streamlines operations, 
        enhances player experience, and ensures fair play. From automating court assignments to tracking attendance and payments, 
        ShuttleOps takes the hassle out of managing your club.`))
  }, [dispatch]);
  return ( 
    <FAQSection full={true}/>
  )
}

export default FAQPage;